import { Activity, Box, Gauge, Radio } from 'lucide-react';
import type { PlatformStatus } from '../types';
import { formatDuration } from '../lib/format';
import { StatusPill } from './StatusPill';

const icons = [Radio, Activity, Gauge];

export function ServiceStatus({ status }: { status: PlatformStatus }) {
  return (
    <section className="service-strip" aria-label="环境与服务状态">
      <div className="release-card">
        <div className="release-card__icon" aria-hidden="true"><Box size={18} /></div>
        <div>
          <span className="eyebrow">当前环境</span>
          <strong>{status.environment}</strong>
        </div>
        <span className="release-card__version">{status.release}</span>
      </div>
      <div className="service-grid">
        {status.components.map((component, index) => {
          const Icon = icons[index % icons.length] ?? Activity;
          return (
            <article className="service-card" key={component.id}>
              <div className="service-card__icon" aria-hidden="true"><Icon size={17} /></div>
              <div className="service-card__main">
                <div className="service-card__title">
                  <strong>{component.name}</strong>
                  <StatusPill status={component.state} compact />
                </div>
                <div className="service-card__meta">
                  <span>{component.version}</span>
                  {component.latencyMs != null && <span>{formatDuration(component.latencyMs)}</span>}
                </div>
                {component.message && <p>{component.message}</p>}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
